import { DigitalProductId } from 'modules/digital-product/types/digital-product-interface'
import { OfferId } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-interface'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { StoreId } from 'modules/stores/types/stores-interface'
import { useItemProductActions } from '../../../hooks/use-item-product-actions'
import {
  ProductECourseItemEditType,
  ProductECourseItemViewType,
} from '../../../types/product-interface'
import { getItemUpdateData } from '../../../utils/get-item-update-data'

export const useSaveCourseItem = ({ storeId }: { storeId: StoreId }) => {
  const { mutate: mutateStore } = useStore(storeId)
  const { createECourse, updateECourse } = useItemProductActions()

  const updateItem = async (
    item: Omit<ProductECourseItemEditType, 'id'> & { id: number },
    digitalProductId: DigitalProductId,
    offerId: OfferId,
  ) => {
    const mutateProductItemData = async (responseData: ProductECourseItemViewType) => {
      await mutateStore(
        data =>
          data && {
            ...data,
            items: data.items.map(i => (i.itemId === responseData.itemId ? responseData : i)),
          },
        false,
      )
    }

    const responseData = await updateECourse(
      item.id,
      getItemUpdateData({ item, digitalProductId, offerId }),
    )

    await mutateProductItemData(responseData)
  }

  const createItem = async (
    item: ProductECourseItemEditType,
    digitalProductId: DigitalProductId,
    offerId: OfferId,
  ) => {
    const mutateProductItemData = async (responseData: ProductECourseItemViewType) =>
      await mutateStore(data => data && { ...data, items: [...data.items, responseData] }, false)

    const responseData = await createECourse(
      storeId,
      getItemUpdateData({ item, digitalProductId, offerId }),
    )

    await mutateProductItemData(responseData)
  }

  const saveItem = async (
    item: ProductECourseItemEditType,
    digitalProductId: DigitalProductId,
    offerId: OfferId,
  ) => {
    if (item.id) {
      await updateItem({ ...item, id: item.id }, digitalProductId, offerId)
    } else {
      await createItem(item, digitalProductId, offerId)
    }
  }

  return {
    updateItem,
    createItem,
    saveItem,
  }
}
